import React, { Component } from "react";
import { Row, Col, Typography, Button, Divider } from "antd";

import SpinBox from "components/SpinBox";
import { BackIcon } from "components/Icons";
import * as API from "utils/api";

import "./MedicareTotals.scss";
import { formatCurrency } from "utils/utils";

const { Title, Text } = Typography;

export default class MedicareTotals extends Component {
  constructor(props) {
    super(props);

    let report_id = "";
    if (this.props.location && this.props.location.state) {
      report_id = this.props.location.state.data.report_id;
    }

    this.state = {
      report_id: report_id,
      medicareInfo: {},
      loading: false,
    };
  }

  componentDidMount() {
    const { report_id } = this.state;

    this.setState({ loading: true });
    API.getMedicareInfoData(report_id).then((res) => {
      this.setState({
        medicareInfo: res.totals,
        loading: false,
      });
    });
  }

  handleUpdateReport = () => {
    const { report_id } = this.state;
    this.props.history.push("/app/reports/msa/nonMedicareCost", {
      data: { report_id: report_id },
    });
  };

  goToPreviousStep = () => {
    this.props.history.goBack();
  };

  render() {
    const { medicareInfo, loading } = this.state;

    return (
      <Row className="msa-medical-totals-container">
        <Row type="flex" align="middle" className="header">
          <Col className="title">
            <Title level={4} className="title-text">
              Setup MSA Report
            </Title>
          </Col>
          <Col className="back" onClick={() => this.props.history.goBack()}>
            <BackIcon className="icon" />
            <Text>Cancel</Text>
          </Col>
          <Col className="step">
            <Text>Step 4 of 17</Text>
          </Col>
        </Row>
        <Row className="main">
          <SpinBox loading={loading}>
            <Row className="content">
              <Row
                type="flex"
                justify="space-between"
                align="middle"
                className="row"
              >
                <Col md={24}>
                  <Text className="title">Totals and Allocations</Text>
                </Col>
              </Row>
              <Row type="flex" className="row">
                <Col className="label">
                  <Text>Annual Cost Total</Text>
                </Col>
                <Text className="text">
                  {formatCurrency(medicareInfo.annual_cost_total || 0)}
                </Text>
              </Row>
              <Row type="flex" className="row">
                <Col className="label">
                  <Text className="label">Recommended Medical Allocation</Text>
                </Col>
                <Text className="text">
                  {formatCurrency(
                    medicareInfo.recommended_medical_allocation || 0
                  )}
                </Text>
              </Row>
              <Row type="flex" className="row">
                <Col className="label">
                  <Text className="label">
                    Surgeries, Replacements and Procedures Allocation
                  </Text>
                </Col>
                <Text className="text">
                  {formatCurrency(
                    medicareInfo.surgeries_replacements_procedures_allocation ||
                      0
                  )}
                </Text>
              </Row>
              <Row type="flex" className="row">
                <Col className="label">
                  <Text className="label">
                    Recommended Prescription Allocation
                  </Text>
                </Col>
                <Text className="text">
                  {formatCurrency(medicareInfo.prescription_allocation || 0)}
                </Text>
              </Row>
              <Row type="flex" className="row">
                <Col className="label">
                  <Text className="label">Recommended Allocation</Text>
                </Col>
                <Text className="text">
                  {formatCurrency(
                    medicareInfo.surgeries_replacements_procedures_allocation +
                      medicareInfo.recommended_medical_allocation +
                      medicareInfo.prescription_allocation || 0
                  )}
                </Text>
              </Row>
              <Divider className="divider" />
              <Row
                type="flex"
                justify="center"
                align="middle"
                className="confirm-button"
              >
                <Button
                  type="link"
                  className="prev-button button"
                  onClick={this.goToPreviousStep}
                >
                  &lt; PREVIOUS STEP
                </Button>
                <Button
                  type="primary"
                  size="large"
                  className="green-btn button"
                  onClick={this.handleUpdateReport}
                >
                  Next Step
                </Button>
              </Row>
            </Row>
          </SpinBox>
        </Row>
      </Row>
    );
  }
}
